@if (label) {
<label class="input-label" [class.disabled]="disabled">{{ label }}</label>
} @if (!isMonthRangePicker) {
<div class="datepicker" [class.disabled]="disabled">
  <input
    class="input"
    matInput
    [matDatepicker]="picker"
    [min]="min"
    [max]="max"
    [disabled]="disabled"
    [class.ng-invalid]="!formControl?.valid"
    [class.ng-valid]="formControl?.valid"
    [class.ng-touched]="formControl?.touched"
    [class.ng-untouched]="!formControl?.touched"
    [class.ng-pristine]="formControl?.pristine"
    [class.ng-dirty]="!formControl?.pristine"
    (blur)="onBlur()"
    [ngClass]="{ 'has-error': hasError }"
    [placeholder]="placeholder"
    (ngModelChange)="updateValue($event)"
    [ngModel]="formControl?.value ?? ''"
    i18n-placeholder="
      Placeholder label | Placeholder for date
      mask@@inputDatepickerPlaceholderLabel"
  />
  <mat-datepicker-toggle matSuffix [for]="picker" [disabled]="disabled">
    <mat-icon
      matDatepickerToggleIcon
      svgIcon="calendar-sm"
      class="calendar-icon"
      [ngClass]="{ 'has-error': hasError }"
    >
    </mat-icon>
  </mat-datepicker-toggle>
  <mat-datepicker #picker></mat-datepicker>
</div>
} @if (isMonthRangePicker) {
<div class="datepicker" [class.disabled]="disabled">
  <input
    class="input"
    matInput
    [placeholder]="placeholder"
    [ngModel]="rangeLabel"
    [class.disabled]="disabled"
    readonly
    (click)="showMonthDatePicker = disabled ? false : !showMonthDatePicker"
    i18n-placeholder="
      Placeholder label | Placeholder for date
      mask@@inputDatepickerPlaceholderLabel"
  />
  <mat-datepicker-toggle
    matSuffix
    (click)="showMonthDatePicker = disabled ? false : !showMonthDatePicker"
    [disabled]="disabled"
  >
    <mat-icon
      matDatepickerToggleIcon
      svgIcon="calendar-sm"
      class="calendar-icon"
      [ngClass]="{ 'has-error': hasError }"
    >
    </mat-icon>
  </mat-datepicker-toggle>
  @if (showMonthDatePicker) {
  <wm-front-month-range-picker
    [period]="monthRangeValue"
    [minRange]="minRange"
    [minDate]="min"
    [maxDate]="max"
    (valueChanged)="updateValue($event)"
    (shouldClose)="showMonthDatePicker = false"
    (reseted)="reset()"
  >
  </wm-front-month-range-picker>
  }
</div>
} @if (hasError) {
<wm-front-form-error
  class="input-error"
  [error]="{
    keys: error?.keys!,
    color: error?.color!,
    position: error?.position!,
    type: formControl?.errors!
  }"
>
</wm-front-form-error>
}
